import type { CollectionProductSample } from '@lib/types'
import type { CustomizationSelectionType, SingleSelectionType } from '@lib/types/customization'

import CustomizationCard from './CustomizationCard'

type CustomizationCardGroupProps = {
	productSamples: CollectionProductSample[]
	currentStep: number
	selections: CustomizationSelectionType[]
	addSelectionToStep: (step: number, newSelection: SingleSelectionType) => void
	deleteSelectionToStep: (step: number, selectionToDelete: SingleSelectionType) => void
}

export default function CustomizationCardGroup({
	productSamples,
	currentStep,
	selections,
	addSelectionToStep,
	deleteSelectionToStep
}: CustomizationCardGroupProps) {
	const selection = selections[currentStep]

	return (
		<div className="flex justify-center w-full">
			<ul className="flex flex-wrap justify-center gap-4 w-full">
				{productSamples.map((productSample, idx) => (
					<CustomizationCard
						currentStep={currentStep}
						stepSelection={selection}
						// eslint-disable-next-line react/no-array-index-key
						key={idx}
						product={productSample}
						addSelectionToStep={addSelectionToStep}
						deleteSelectionToStep={deleteSelectionToStep}
					/>
				))}
			</ul>
		</div>
	)
}
